module.exports = __webpack_public_path__ + "static/img/ewm_bg.3c0345c9.png";